<div class="input-date">
	<div class="input-date-composant p-inputgroup">
		<div class="d-flex flex-column stacked-button-container">
			<button type="button" pButton pRipple icon="pi pi-angle-up" class="stacked-button-haut" (click)="calculerDate(false, true, true)"></button>
			<button type="button" pButton pRipple icon="pi pi-angle-down" class="stacked-button-bas" (click)="calculerDate(false, true, false)"></button>
		</div>
		<div class="d-flex" (click)="ouvrirSelection()">
			<p-inputMask [ngModel]="formatterDate()" mask="99/99/9999 99:99:99 - 99/99/9999 99:99:99" [readonly]="true"></p-inputMask>
			<button type="button" pButton pRipple icon="pi pi-calendar"></button>
		</div>
	</div>
	<p-overlay [(visible)]="selecteurDateOuvert" class="selecteur-date" (onHide)="fermetureSelecteurDate()">
		<p-tabView>
			<p-tabPanel header="{{'SELECTEUR_DATE.TITRE_ACCES_RAPIDE' | translate}}">
				<div class="d-flex flex-row tab-acces-rapides mx-auto">
					<div class="d-flex flex-column mx-2 h-100">
						<div *ngFor="let accesRapide of accesRapidesMinutes" class="acces-rapide">
							<p-radioButton [inputId]="accesRapide.id"
										   [value]="accesRapide"
										   [(ngModel)]="accesRapideSelectionne"
										   (onClick)="calculerDate(true)"
										   class="mr-2px"
							></p-radioButton>
							<label [for]="accesRapide.id" class="cursor-pointer mt-1">{{ accesRapide.label | translate }}</label>
						</div>
					</div>
					<p-divider layout="vertical"></p-divider>
					<div class="d-flex flex-column mx-2 h-100">
						<div *ngFor="let accesRapide of accesRapidesHeures" class="acces-rapide">
							<p-radioButton [inputId]="accesRapide.id"
										   [value]="accesRapide"
										   [(ngModel)]="accesRapideSelectionne"
										   (onClick)="calculerDate(true)"
										   class="mr-2px"
							></p-radioButton>
							<label [for]="accesRapide.id" class="cursor-pointer mt-1">{{ accesRapide.label | translate }}</label>
						</div>
					</div>
					<p-divider layout="vertical"></p-divider>
					<div class="d-flex flex-column mx-2 h-100">
						<div *ngFor="let accesRapide of accesRapidesJours" class="acces-rapide">
							<p-radioButton [inputId]="accesRapide.id"
										   [value]="accesRapide"
										   [(ngModel)]="accesRapideSelectionne"
										   (onClick)="calculerDate(true)"
										   class="mr-2px"
							></p-radioButton>
							<label [for]="accesRapide.id" class="cursor-pointer mt-1">{{ accesRapide.label | translate }}</label>
						</div>
					</div>
				</div>
			</p-tabPanel>
			<p-tabPanel header="{{'SELECTEUR_DATE.TITRE_DATE_RELATIVE' | translate}}">
				<div class="d-flex flex-row tab-date-relative">
					<div class="d-flex flex-row w-100 mx-2">
						<div class="d-flex flex-column mr-3 w-50">
							<b class="mb-1">{{ 'SELECTEUR_DATE.LABEL_DUREE' | translate }}</b>
							<p-inputNumber [(ngModel)]="duree" (focusout)="calculerDate()" [showButtons]="true" [min]="0"></p-inputNumber>
						</div>
						<div class="d-flex flex-column w-50">
							<b class="mb-1">{{ 'SELECTEUR_DATE.LABEL_UNITE_TEMPS' | translate }}</b>
							<p-dropdown [options]="unitesTemps" [(ngModel)]="uniteTempsSelectionnee" (ngModelChange)="calculerDate()">
								<ng-template let-unite pTemplate="selectedItem">
									{{ unite.nom | translate }}
								</ng-template>
								<ng-template let-unite pTemplate="item">
									{{ unite.nom | translate }}
								</ng-template>
							</p-dropdown>
						</div>
					</div>
				</div>
			</p-tabPanel>
			<p-tabPanel header="{{'SELECTEUR_DATE.TITRE_DATE_ABSOLUE' | translate}}">
				<div class="d-flex flex-row tab-date-absolue w-100" >
					<div class="d-flex flex-column mx-2 w-50">
						<b class="mb-1">{{ 'SELECTEUR_DATE.LABEL_DATE_DEBUT' | translate }}</b>
						<p-calendar [(ngModel)]="dateDebut"
									(onSelect)="gererSelectionDateAbsolue()"
									(focusout)="gererSelectionDateAbsolue()"
									[showIcon]="true"
									[showTime]="true"
									[showSeconds]="true"
									[focusTrap]="false"
									[ngClass]="{'ng-invalid ng-dirty': verificationOrdreDatesIncorrect()}"
									dateFormat="dd/mm/yy"
									class="w-100">
						</p-calendar>
					</div>
					<div class="d-flex flex-column w-50 mx-2">
						<b class="mb-1">{{ 'SELECTEUR_DATE.LABEL_DATE_FIN' | translate }}</b>
						<p-calendar [(ngModel)]="dateFin"
									(onSelect)="gererSelectionDateAbsolue()"
									(onClickOutside)="gererSelectionDateAbsolue()"
									[showIcon]="true"
									[showTime]="true"
									[showSeconds]="true"
									[ngClass]="{'ng-invalid ng-dirty': verificationOrdreDatesIncorrect()}"
									dateFormat="dd/mm/yy"
									class="w-100">
						</p-calendar>

					</div>
				</div>
			</p-tabPanel>
			<div class="d-flex flex-row justify-content-between mt-1">
				<button pButton pRipple (click)="reinitialiserDate()" class="bouton-reinitialiser p-button-text mt-3">{{ 'SELECTEUR_DATE.LABEL_BOUTON_REINITIALISER_DATE' | translate }}</button>
				<p-button (click)="fermetureSelecteurDate()" label="{{'SELECTEUR_DATE.LABEL_BOUTON_VALIDER' | translate}}" icon="pi pi-check" class="bouton-valider mt-3 mr-2"></p-button>
			</div>
		</p-tabView>
	</p-overlay>
</div>
